import { Component } from "excalibur";

export class AutoCleanupComponent extends Component {}
